
























































































import {Vue, Component, Prop} from 'vue-property-decorator';
import ExcelDownloadButton from '@/components/header/ExcelDownloadButton.vue';
import { GetMenusFavorite, GetMainMenus } from 'supporter';
import { openProAdminContentsPopup } from '@/utils/commonUtils';
import { initFavoriteMenu, excludePath, TOGGLE_GROUP_SELECT, NOT_GROUP_SELECT, INIT_GROUP_SELECT } from './gnbWrap';

type GetMenusFavoriteCustom = GetMenusFavorite & { isCheck?: boolean };

@Component({
  components: {
    ExcelDownloadButton,
  },
})
export default class GnbWrap extends Vue {
  @Prop() private menuGroups!: GetMainMenus[];
  @Prop() private showMenus!: any;
  @Prop() private onSelectApp!: (no:number)=>void;

  private selectedGnbNo = NOT_GROUP_SELECT;
  private lnbMenus: GetMainMenus[] = [];
  private favoriteMenus: GetMenusFavoriteCustom[] = [];
  private selectedIndex = 0;
  private movedIndex: null | number = null;

  private kakaoFriendAppNo = process.env.VUE_APP_KAKAO_FRIENDS_APP_NO;

  private getGroupNo() {
    let onGroupNo = INIT_GROUP_SELECT;

    if (this.selectedGnbNo === NOT_GROUP_SELECT) {
      const currentPath = this.getCurrentPath();

      this.menuGroups.forEach(({ menus, order }) => {
        menus.forEach(menu => {
          if (menu.uri === currentPath || menu.menus.find(({ uri }) => uri === currentPath)) {
            onGroupNo = order;
          }
        });
      });
    } else {
      onGroupNo = this.selectedGnbNo;
    }

    return onGroupNo;
  }

  private toggleGroup({ order }: GetMainMenus) {    
    this.selectedGnbNo = order === this.getGroupNo() ? TOGGLE_GROUP_SELECT : order;
    this.favoriteMenus = this.favoriteMenus.filter(({ isCheck }) => isCheck);
  }

  private isProPopup(uri:string){
    return excludePath.includes(uri) ? false : uri.includes('/premium');
  }

  private openPopup(uri:string){
    openProAdminContentsPopup(uri);
  }

  private getCurrentPath() {
    const { matched, path } = this.$route;
    let currentPath = matched[matched.length - 1].path;

    if (currentPath.indexOf(':') > -1) {
      currentPath = currentPath.split('/').map(item => item.indexOf(':') > -1 ? '*' : item).join('/');
    } else {
      currentPath = path;
    }

    if (currentPath.lastIndexOf('/') === currentPath.length - 1) {
      currentPath = currentPath.substr(0, currentPath.length - 1);
    }

    return currentPath;
  }

  private isCurrentPath(uri: string, menus?: GetMainMenus[]) {
    const currentPath = this.getCurrentPath();


    const findPath = (menusProp: GetMainMenus[]) => menusProp?.find(({ uri, menus: subMenes }) => {
     return  uri === currentPath || findPath(subMenes);
    });

    return uri === currentPath || findPath(menus);
  }

  private async setMenusFavorites() {
    const { data: favorites } = await this.$api.getMenusFavorites();
    this.favoriteMenus = favorites.map((item) => ({ ...item, isCheck: true }));
  }

  private async putMenusFavoritesOrders(menu: GetMenusFavoriteCustom[]) {
    await this.$api.putMenusFavoritesOrders({
      data: {
        favorites: menu.map(({ menuFavoriteNo }, order) => ({
          menuFavoriteNo,
          order,
        })),
      },
    });
  }

  private async putFavoritesMenu(menuNo: number, appNo = null) {
    await this.$api.putMenusFavorites({ params: { menuNo, appNo } });

    if (this.favoriteMenus.find(item => appNo ? item.appNo === appNo : item.menuNo === menuNo)) {
      this.favoriteMenus = this.favoriteMenus.map(menu => ({
        ...menu,
        isCheck: appNo ? appNo === menu.appNo ? !menu.isCheck : menu.isCheck : menuNo === menu.menuNo ? !menu.isCheck : menu.isCheck,
      }));

      this.putMenusFavoritesOrders(this.favoriteMenus);

      return;
    }

    this.setMenusFavorites()
  }

  private dragstart(index: number) {
    this.selectedIndex = index;
  }

  private dragleave(index: number) {
    const element = this.$refs.draggableElement[index] as HTMLDivElement;
    element.classList.remove('over-top', 'over-bottom');
  }

  private dragover({ clientY }: DragEvent, index: number) {
    const overElement = this.$refs.draggableElement[index] as HTMLDivElement;
    const { top, height } = overElement.getBoundingClientRect();
    const isPositionUp = clientY > top + height / 2;

    if (isPositionUp) {
      overElement.classList.add('over-bottom');
      overElement.classList.remove('over-top');
    } else {
      overElement.classList.add('over-top');
      overElement.classList.remove('over-bottom');
    }

    if (
      (this.selectedIndex > index && !isPositionUp) ||
      (this.selectedIndex < index && isPositionUp) ||
      this.selectedIndex === index
    ) {
      this.movedIndex = index;
    }
  }

  private async dragDrop() {
    const filteredMenus = this.favoriteMenus.filter((_, index) => index !== this.selectedIndex);
    filteredMenus.splice(this.movedIndex, 0, this.favoriteMenus[this.selectedIndex]);
    (this.$refs.draggableElement as HTMLDivElement[]).forEach(({ classList }) =>
      classList.remove('over-top', 'over-bottom'),
    );

    this.putMenusFavoritesOrders(filteredMenus);
    this.favoriteMenus = filteredMenus;
  }

  async created() {
    await this.setMenusFavorites();
    this.lnbMenus = [initFavoriteMenu(), ...this.showMenus];

    if (this.favoriteMenus.find((item) => item.uri === this.getCurrentPath())) {
      this.selectedGnbNo = INIT_GROUP_SELECT
    }
  }
}
